<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
body, h1, h2, h3, h4, h5, h6, hr, p, blockquote, dl, dt, dd, ul, ol, li, pre, form, fieldset, legend, button, input, textarea, th, td { margin:0; padding:0; }
body, button, input, select, textarea { font:12px/1.5 tahoma, arial, \5b8b\4f53; }
address, cite, dfn, em, var { font-style:normal; }
code, kbd, pre, samp { font-family:"微软雅黑", courier, monospace; }
small{ font-size:12px; }
ul, ol { list-style:none; }
a { text-decoration:none; }
a:hover { text-decoration:underline; }
sup { vertical-align:text-top; }
sub{ vertical-align:text-bottom; }
legend { color:#000; }
fieldset, img { border:0; }
button, input, select, textarea { font-size:100%; }
table { border-collapse:collapse; border-spacing:0; } 
#app .tables { width: 100%;}
#app .tables th, .tables td { text-align: center; }
#app .table-expand { font-size: 0; }
#app .table-expand label { width: 90px; color: #99a9bf; }
#app .table-expand .el-form-item { margin-right: 0; margin-bottom: 0; width: 48%; margin-right: 1%; white-space: nowrap; text-overflow: ellipsis;overflow: hidden; }
#app .el-table__expanded-cell[class*=cell] { text-align: left; }
#app .m0 { margin: 0 !important; }
#app .ban-on-line { white-space: nowrap; text-overflow: ellipsis; overflow: hidden; cursor: pointer; }
#app .mt10{ margin-top: 10px; }
#app .mt20{ margin-top: 20px; }
#app .mt30{ margin-top: 30px; }
#app .mb10{ margin-bottom: 10px; }
#app .mb20{ margin-bottom: 20px; }
#app .mb30{ margin-bottom: 30px; }
#app body { font-size: 16px; }
#app select { outline: none; }
#app .clearfix { zoom: 1 }
#app .clearfix::after { height: 0; line-height: 0; content: ""; display: block; visibility: hidden; clear: both; }
#app .pull-left { float: left; }
#app .pull-right { float: right; }
#app .nav-bar { background-color: #30d1ff; }
#app .nav-bar .title { color: #fff; }
#app .text-center { text-align: center; }
#app .text-left { text-align: left; }
#app .text-right { text-align: right; }
#app .text-white { color: #fff; }
#app .btn-primary { background-color: #30d1ff; color: #fff; }
</style>



// WEBPACK FOOTER //
// src/App.vue